import styled from 'styled-components';

export const Divider = styled.div`
	border-bottom: 1px solid ${props => props.theme.colors.border};
	width: 100%;
`;
